import { Routes, Route, Outlet } from "react-router-dom";
import UsinasContextProvider from "../context/UsinasContextProvider";
import UsinasList from "../pages/UsinasList";
import NewUsina from "../pages/NewUsina";
import UsinaDetails from "../components/UsinaDetails";
import { useContext } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import ReportDaily from "../pages/ReportDaily";
import ReportMonth from "../pages/ReportMonth";
import ReportList from "../pages/ReportList";
import ReportPersonalized from "../pages/PersonalizedReport";
import PartialReport from "../pages/PartialReport";

export default function UsinasRoutes() {
  const { userIsAdm, userIsClient, userIsManutencao } = useContext(MainContext);

  return (
    <>
      <UsinasContextProvider>
        <Routes>
          <Route path="/" element={<UsinasList />} />
          <Route path="/:id" element={<UsinaDetails />} />
          <Route path="/details/:id" element={<UsinaDetails />} />
          {!userIsManutencao && (
            <>
              <Route path="/boletim-diario" element={<ReportDaily />} />
              <Route path="/boletim-mensal" element={<ReportMonth />} />
            </>
          )}

          <Route path="/boletim-personalizado" element={<ReportPersonalized />} />
          <Route path="/boletim-parcial" element={<PartialReport />} />

          {(userIsAdm || userIsClient) && (
            <>
              <Route path="/cadastrar" element={<NewUsina />} />
              <Route path="/:id/editar" element={<NewUsina />} />
            </>
          )}

          {userIsAdm &&
            <>
              <Route path="/relatorios" element={<ReportList />} />
            </>
          }
          <Route path="/*" element={<EmptyStateNotFound />} />
        </Routes>
        <Outlet />
      </UsinasContextProvider>
    </>
  );
}
